"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "calculateCanManuallySendReminders", {
    enumerable: true,
    get: function() {
        return calculateCanManuallySendReminders;
    }
});
const _datefns = require("date-fns");
const calculateCanManuallySendReminders = (surveyCreatedAt, lastReminderSentAt, reminderCadence, cooldownDays = 0)=>{
    const lastReminderSent = lastReminderSentAt ? lastReminderSentAt : surveyCreatedAt;
    const daysLastReminderSentFromStart = (0, _datefns.differenceInDays)(lastReminderSent, surveyCreatedAt);
    const adjustedReminderCadence = reminderCadence.concat(daysLastReminderSentFromStart).sort();
    const reminderCadenceIntervals = adjustedReminderCadence.map((cadence)=>({
            start: (0, _datefns.addDays)(surveyCreatedAt, cadence - cooldownDays),
            end: (0, _datefns.addDays)(surveyCreatedAt, cadence + cooldownDays),
            cadenceDate: (0, _datefns.addDays)(surveyCreatedAt, cadence)
        }));
    const firstAvailableDateOutsideCadence = recursivelyCheckCadenceDates(reminderCadenceIntervals, new Date());
    if ((0, _datefns.isAfter)(firstAvailableDateOutsideCadence, new Date())) {
        return {
            canSend: false,
            error: `Cannot send manual reminder emails, next reminder date is within cooldown period. Will be available on ${(0, _datefns.format)(firstAvailableDateOutsideCadence, "MM/dd/yyyy")}`,
            availableOn: firstAvailableDateOutsideCadence
        };
    } else {
        return {
            canSend: true,
            error: "",
            availableOn: new Date()
        };
    }
};
// this function should recursively check cadence dates in order to find the first available end date outside a cadence that is after the check date
const recursivelyCheckCadenceDates = (cadenceDates, checkDate)=>{
    const currentCadenceDate = cadenceDates.find((cadence)=>(0, _datefns.isWithinInterval)(checkDate, {
            start: cadence.start,
            end: cadence.end
        }));
    if (currentCadenceDate) {
        return recursivelyCheckCadenceDates(cadenceDates, (0, _datefns.addSeconds)(currentCadenceDate.end, 1));
    } else {
        return checkDate;
    }
};
